import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-dot',
  templateUrl: './dot.component.html',
  styleUrls: ['./dot.component.scss']
})
export class DotComponent implements OnInit {

  @Input() public navigateTo: string;
  @Input() public name: string;
  @Input() public selected = false;
  constructor() { }

  ngOnInit() {
  }

  scroll(navigateTo: string) {
    const targetScroll = document.getElementById(navigateTo);
    this.scrollTo(targetScroll);
    }

  scrollTo(element: HTMLElement) {
    console.log('scrolling');
    element.scrollIntoView(true);
  }


}
